import type { FireflyRuntime } from "@squide/firefly";
import { handleForbiddenError } from "./handleForbiddenError.ts";
import { handleUnauthorizedError } from "./handleUnauthorizedError.ts";
import { isDefinedError, ORPCError } from "@orpc/client";

export type UnmanagedQueryErrorHandler = (error: Error) => void;

export function createUnmanagedQueryErrorHandler(runtime: FireflyRuntime) {
    const handler: UnmanagedQueryErrorHandler = error => {
        if (error instanceof ORPCError) {
            if (error.status === 401) {
                handleUnauthorizedError(error, runtime);

                return;
            }

            if (error.status === 403 && !isDefinedError(error)) {
                handleForbiddenError(error, runtime);

                return;
            }
        }

        runtime.logger.withText("[web-app] An unmanaged query error occurred:").withError(error).error();

        throw error;
    };

    return handler;
}
